<template>
  <a
     :class="item.class"
     @click="item.event(item.params)"
  >
    {{item.values}}
  </a>
</template>
<script>
export default {
  name: 'TableTypeButtonBox',
  props: ['item'],
}
</script>